import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FormProvider, useForm } from "react-hook-form";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import {
    CadastrarDataDeCorteController,
    ListarVistoriasController,
} from "../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import {
    IGestaoDeEntregaChavesRequest,
    IGestaoVistoriaResponse,
} from "../../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
import StorageManagerCapys from "../../../Tools/Storage";
import FiltroEntregaChaves from "../GestaoAtendimentos/FiltrosEntregaChaves";
import UnForm from "../../../Components/Form";
import moment from "moment";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

export default function AgendamentoCorte() {
    const FormMethods = useForm();
    const { PageFilter, filter, setPageFilter, setPage, setFilter } =
        usePaginationFilter<IGestaoDeEntregaChavesRequest>({ page: 1 });
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const filterStorage = new StorageManagerCapys<IGestaoVistoriaResponse>(
        "FILTRO_GESTAO_VISTORIA"
    );
    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number>(
        ""
    );
    const [formularioCorte, setFormularioCorte] = useState<Array<number>>();
    const [pesquisaText, setPesquisaText] = useState("");

    const {
        value: listarFormulariosVistoria,
        loading: listarFormulariosVistoriaLoading,
        execute: updateList,
    } = useAsyncEffect(
        async () =>
            ListarVistoriasController(PageFilter.page, { ...filter } ?? {}),
        [PageFilter.filter, PageFilter.page]
    );

    const totalPaginas = listarFormulariosVistoria?.NR_PAGINAS;

    const agendamentoCorteColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "",
            isDummyField: true,
            formatter: agendamentoCorteFormatter,
            headerClasses: "d-none",
        },
    ];

    function agendamentoCorteFormatter(
        cell: any,
        row: IGestaoVistoriaResponse["Vistorias"][0]
    ) {
        return (
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="d-flex flex-column">
                        <div>
                            <span>
                                <strong>EMPREENDIMENTO:</strong>{" "}
                                {row.DS_EMPREENDIMENTO}
                            </span>
                        </div>
                        <div>
                            <span>
                                <strong>UNIDADE:</strong> {row.DS_UNIDADE}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-column">
                        <div>
                            <span>
                                <strong>CLIENTE:</strong> {row.DS_NOME}
                            </span>
                        </div>
                        <div>
                            <span>
                                <strong>ETAPA VISTORIA:</strong> {row.DS_ETAPA}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="card-body d-flex justify-content-between">
                    <div className="d-flex flex-column">
                        <div>
                            <span>
                                <strong>CASO VISTORIA:</strong> {row.ID_CASO}
                            </span>
                        </div>
                        <div>
                            <span>
                                <strong>Data Corte Início:</strong>{" "}
                                {row.DT_CORTE_INICIO
                                    ? moment(row.DT_CORTE_INICIO).format("LLL")
                                    : "Data Corte Início Pendente"}
                            </span>
                        </div>
                        <div>
                            <span>
                                <strong>Data Corte Fim:</strong>{" "}
                                {row.DT_CORTE_FIM
                                    ? moment(row.DT_CORTE_FIM).format("LLL")
                                    : "Data Corte Fim Pendente"}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-column">
                        <div>
                            <span>
                                <strong>Data Agendamento:</strong>{" "}
                                {row.DT_AGENDA
                                    ? moment(row.DT_AGENDA).format("LLL")
                                    : "Data Agendamento Pendente"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const tableviewColumns: Array<
        ColumnDescription<IGestaoVistoriaResponse["Vistorias"][0]>
    > = [
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "EMPREENDIMENTO",
        },
        {
            dataField: "DS_UNIDADE",
            text: "UNIDADE",
        },
        {
            dataField: "DS_NOME",
            text: "CLIENTE",
        },
        {
            dataField: "ID_CASO",
            text: "CASO VISTORIA",
        },
        {
            dataField: "DS_ETAPA",
            text: "ETAPA VISTORIA",
        },
        {
            dataField: "DT_CORTE_INICIO",
            text: "Data Corte Início",
            formatter: (c, row) => (
                <div>
                    {row.DT_CORTE_INICIO
                        ? moment(row.DT_CORTE_INICIO).format("LLL")
                        : "Data Corte Início Pendente"}
                </div>
            ),
        },
        {
            dataField: "DT_CORTE_FIM",
            text: "Data Corte Fim",
            formatter: (c, row) => (
                <div>
                    {row.DT_CORTE_FIM
                        ? moment(row.DT_CORTE_FIM).format("LLL")
                        : "Data Corte Fim Pendente"}
                </div>
            ),
        },
        {
            dataField: "DT_AGENDA",
            text: "Data Agendamento",
            formatter: (c, row) => (
                <div>
                    {row.DT_AGENDA
                        ? moment(row.DT_AGENDA).format("LLL")
                        : "Data Agendamento Pendente"}
                </div>
            ),
        },
    ];

    const ultimaPesquisaRef = useRef("");

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    PESQUISA: newState.searchText,
                    PAGINA: newState.page,
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    function handleSubmitDataCorte(
        dtInicio: string,
        dtFim: string,
        idsProdutos: number[]
    ) {
        CadastrarDataDeCorteController(dtInicio, dtFim, idsProdutos).then(
            () => {
                setShow(false);
                updateList();
            }
        );
    }

    return (
        <FormProvider {...FormMethods}>
            <div className="card card-custom p-10">
                <div>
                    <button
                        className="btn btn-outline-success font-weight-bold mb-4"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Agendar data de corte",
                                IconHeader: faCalendar,
                                Component: () => (
                                    <UnForm
                                        handleSubmit={(formData) => {
                                            handleSubmitDataCorte(
                                                formData.DT_INICIO,
                                                formData.DT_FIM,
                                                formularioCorte ?? []
                                            );
                                        }}
                                    >
                                        {({ getValues }) => (
                                            <>
                                                <div className="col-12 mt-3">
                                                    <label>Data Inicio</label>

                                                    <UnForm.Input
                                                        className="form-control"
                                                        type="date"
                                                        name="DT_INICIO"
                                                        registerOptions={{
                                                            validate: (
                                                                dtInicio
                                                            ) => {
                                                                if (
                                                                    dtInicio <=
                                                                    getValues(
                                                                        "DT_FIM"
                                                                    )
                                                                )
                                                                    return true;
                                                                else
                                                                    return "A data início tem que ser menor do que data fim";
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-12 mt-3">
                                                    <label>Data Final</label>
                                                    <UnForm.Input
                                                        className="form-control"
                                                        type="date"
                                                        name="DT_FIM"
                                                        registerOptions={{
                                                            validate: (
                                                                dtFim
                                                            ) => {
                                                                if (
                                                                    dtFim >=
                                                                    getValues(
                                                                        "DT_INICIO"
                                                                    )
                                                                )
                                                                    return true;
                                                                else
                                                                    return "A data fim tem que ser maior do que data início";
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                <button className="btn btn-success d-flex align-items-center justify-content-center w-100 ml-3 mr-3 g-2 m-3">
                                                    Incluir
                                                </button>
                                            </>
                                        )}
                                    </UnForm>
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        Incluir Data de corte Agendado
                    </button>
                </div>
                <Table
                    keyField="ID"
                    columns={agendamentoCorteColumns}
                    wrapperClasses="mw-100 custom-scroll"
                    tableView={{
                        columns: tableviewColumns,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    selectRow={{
                        mode: "checkbox",
                        clickToSelect: true,
                        clickToEdit: true,
                        onSelect: (row, isSelect) => {
                            if (isSelect) {
                                setFormularioCorte((id) => [
                                    ...(id ?? []),
                                    row.ID_PRODUTO,
                                ]);
                            } else {
                                setFormularioCorte(
                                    (lstId) =>
                                        lstId?.filter(
                                            (id) => id !== row.ID_PRODUTO
                                        ) ?? []
                                );
                            }
                        },
                        onSelectAll: (isSelect, rows) => {
                            if (isSelect) {
                                setFormularioCorte((idsContatos) => [
                                    ...(idsContatos ?? []),
                                    ...rows.map(
                                        (contatos) => contatos.ID_PRODUTO
                                    ),
                                ]);
                            } else {
                                setFormularioCorte([]);
                            }
                        },
                    }}
                    remote={{ pagination: true, filter: true }}
                    data={listarFormulariosVistoria?.Vistorias ?? []}
                    loading={listarFormulariosVistoriaLoading}
                    onTableChange={(_type, newState) => {
                        const state = newState as IPropsTableChange;

                        if (state.searchText !== "") {
                            handleSearch(state.searchText, state);
                            setPesquisaText(state.searchText);
                        } else if (pesquisaText.length > 0) {
                            setFilter({ PESQUISA: state.searchText });
                        } else {
                            setPage(state.page);
                        }
                    }}
                    totalPages={totalPaginas}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhum Formulário Encontrado
                        </div>
                    )}
                    rowStyle={{ height: 50 }}
                    striped={true}
                    noHover
                />
                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />

                <FiltroEntregaChaves
                    handleSubmit={(formData) => {
                        setPageFilter({
                            filter: formData,
                            page: 1,
                        });
                    }}
                    storageManager={filterStorage}
                    defaultFilter={filter}
                    setIdEmpreendimento={setIdEmpreendimento}
                    idEmpreendimento={idEmpreendimento}
                />
            </div>
        </FormProvider>
    );
}
